import * as React from "react";
const SvgPerson20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 18,
        viewBox: "0 0 16 18",
        fill: "black"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5.5 4.75a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM8.25 0a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM5 11a5 5 0 0 0-5 5v2h2v-2a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v2h2v-2a5 5 0 0 0-5-5H5Z",
      clipRule: "evenodd"
    })
  );
export default SvgPerson20Px;
